var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 50,
    rx: 8,
    fill: "#2563EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15H40V35H30V15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15H60V35H50V15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 15H80V35H70V15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 15H100V35H90V15Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110 15H120V35H110V15Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130 15H140V35H130V15Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150 15H160V35H150V15Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170 15H180V35H170V15Z",
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 40,
    fontFamily: "Arial",
    fontSize: 24,
    fontWeight: "bold",
    fill: "white"
  }, "Liberty")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.19f6847a87214643b97bbff776f800f3.svg";
export { ForwardRef as ReactComponent };